/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { 
    NgModule, NgZone, Component, ElementRef, Renderer, Input, Output, 
    forwardRef, EventEmitter, SimpleChanges 
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcLinkComponent),
    multi: true
};

/**
 * Icon Link
 */

export class NgcLinkComponent extends ControlComponent {
    private _displayColor:string = "black";
    private _color:string = "black";
    //
     public title:string = "";
     public iconClass:string = "";
     public linkClass:string = "small";

    //
     private clickEmitter: EventEmitter<any>;
    
    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * Sets Color
     */
    
    public set color(color: string) {
        if (!this.disabled && this._color !== color) {
            this._color = color;
            this.modelUpdated(this._color);
        } else if(this.disabled) {
            this._color = color;
            this.disabledUpdateCallback();
        }
    }

    /**
     * Gets Color
     */
    public get color(): string {
        return this._color;
    }

    /**
     * Calls on Disabled State Update
     */
    public disabledUpdateCallback(): void {
        if (this.disabled) {
            this._displayColor = "grey";
        }
    }

    /**
     * On Click
     * 
     * @param event Event
     */
    public onClick(event) {
        if (this.value && this.clickEmitter && !this.disabled) {
            this.clickEmitter.emit(this.value);
        }
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-link',
    template: `
            <a *ngIf="visible" [ngClass]="linkClass" href="javascript:void(0)" (click)="onClick($event)">
                <i [ngClass]="iconClass" [style.color]="_displayColor" aria-hidden="true"></i>
                {{ title }}
            </a>
            `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'title': [{ type: Input, args: ["title", ] },],
'iconClass': [{ type: Input, args: ["iconClass", ] },],
'linkClass': [{ type: Input, args: ["linkClass", ] },],
'clickEmitter': [{ type: Output, args: ["linkClick", ] },],
'color': [{ type: Input, args: ["color", ] },],
};
}

/**
 * Link Module
 */

export class NgcLinkModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [NgcLinkComponent],
    declarations: [NgcLinkComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
